$(function () {
  // ----------------------
  // TOPファーストビュー
  // ----------------------
  function firstParallax() {
    $('section.firstview.top div.video').each(function () {
      var $wrapper = $(this);
      var scrollTop = $(window).scrollTop();
      var offsetTop = $wrapper.offset().top;
      var distance = (scrollTop - offsetTop) * 0.2;
      distance = Math.max(Math.min(distance, 500), -500);
      $wrapper.find('img,video').css('transform', 'scale(1) translateY(' + distance + 'px)');
    });
    requestAnimationFrame(firstParallax);
  }

  // ----------------------
  // フッター
  // ----------------------
  function footerParallax() {
    $('footer ul.slide li').each(function () {
      var $wrapper = $(this);
      var scrollTop = $(window).scrollTop();
      var offsetTop = $wrapper.offset().top;
      var distance = (scrollTop - offsetTop) * 0.2;
      distance = Math.max(Math.min(distance, 500), -500);
      $wrapper.find('img,video').css('transform', 'scale(1.3) translateY(' + distance + 'px)');
    });
    requestAnimationFrame(footerParallax);
  }

  // ----------------------
  // 汎用パララックス用
  // ----------------------
  function updateCommonParallax() {
    $('div.parallax_visual').each(function () {
      var $wrapper = $(this);
      var scrollTop = $(window).scrollTop();
      var offsetTop = $wrapper.offset().top;
      var distance = (scrollTop - offsetTop) * 0.2;
      distance = Math.max(Math.min(distance, 500), -500);
      $wrapper.find('img,video').css('transform', 'scale(1) translateY(' + distance + 'px)');
    });
    requestAnimationFrame(updateCommonParallax); // ✅ 忘れずループ
  }

  // DOM読み込み後 + 画像読み込み後にループ開始
  $(window).on('load', function () {
    requestAnimationFrame(firstParallax);
    requestAnimationFrame(footerParallax);
    requestAnimationFrame(updateCommonParallax);
  });
});
